import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgX = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.8332 1.33337H13.8786L9.41102 6.98081L14.6667 14.6667H10.5526L7.32787 10.0065L3.64251 14.6667H1.59413L6.37176 8.62504L1.33337 1.33337H5.55183L8.46361 5.59299L11.8332 1.33337ZM11.1146 13.3141H12.2475L4.93471 2.61543H3.71784L11.1146 13.3141Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgX)
const IconSvgX = createIcon(ForwardRef, 'SvgX')
export default IconSvgX
